import { render, staticRenderFns } from "./ColumnHeaderGroup.vue?vue&type=template&id=b6825804&"
import script from "./ColumnHeaderGroup.vue?vue&type=script&lang=js&"
export * from "./ColumnHeaderGroup.vue?vue&type=script&lang=js&"
import style0 from "./ColumnHeaderGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports